// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/lecture-workload-summary-status-item-schema',
  type: 'object',
  required: ['totalDays', 'totalDaysTT', 'statusId'],
  nullable: true,
  properties: {
    name: {
      type: 'string',
      nullable: true,
    },
    totalDays: {
      type: 'number',
    },
    totalDaysTT: {
      type: 'number',
    },
    statusId: {
      type: 'integer',
    },
    htmlColor: {
      type: 'string',
      nullable: true,
    },
    eventTypeId: {
      type: 'integer',
      nullable: true,
    },
    isIncludedInWorkload: {
      type: 'boolean',
    },
    isInOwnClass: {
      type: 'boolean',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
